import React from "react";
import { Link } from "react-router-dom";

const getEmbedUrl = (video) => {
  if (!video?.platform_id) return null;
  if (video.platform === "instagram") {
    return `https://www.instagram.com/p/${video.platform_id}/embed?hidecaption=false&maxwidth=320`;
  }
  if (video.platform === "youtube") {
    return `https://www.youtube.com/embed/${video.platform_id}`;
  }
  return null;
};

/**
 * Renders a lazy-loaded platform embed (Instagram, YouTube) for a video object.
 * If `path` is provided, an invisible overlay Link captures clicks and navigates
 * to that path instead of letting the iframe receive interaction.
 * If both `path` and `overlayText` are set, hovering shows a semi-transparent overlay (theme
 * background at 0.75 opacity) with the text; the overlay transitions in.
 */
const VideoPreview = ({ video, path, overlayText }) => {
  const embedUrl = getEmbedUrl(video);

  if (!embedUrl) return null;

  return (
    <div className="relative rounded-lg overflow-hidden bg-theme-secondary border border-theme-secondary aspect-[9/16]">
      <iframe
        src={embedUrl}
        loading="lazy"
        className="w-full h-full"
        frameBorder="0"
        allowFullScreen
        scrolling="no"
        title={video?.title || "Video"}
      />
      {path && (
        <Link
          to={path}
          className="absolute inset-0 group flex items-center justify-center"
          aria-label={video?.title || "View video"}
        >
          {overlayText && (
            <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span className="absolute inset-0 bg-theme-main opacity-75" aria-hidden />
              <span className="relative z-10 text-theme-text text-sm font-medium">{overlayText}</span>
            </span>
          )}
        </Link>
      )}
    </div>
  );
};

export default VideoPreview;
